export function stripNullBytes(raw: string): string {
  return raw.replaceAll("\0", "");
}

export function stripNullBytesDeep<T>(value: T): T {
  if (typeof value === "string") return stripNullBytes(value) as T;
  if (Array.isArray(value)) return value.map(stripNullBytesDeep) as T;
  if (
    value &&
    typeof value === "object" &&
    !(value instanceof Date) &&
    !ArrayBuffer.isView(value)
  )
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [
        stripNullBytes(key),
        stripNullBytesDeep(item),
      ])
    ) as T;
  return value;
}
